module.exports = __webpack_public_path__ + "img/Thumb_FirePearl.47659544.jpg";